import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { LoginComponent } from './app/pages/pages/auth/login/login.component';
 bootstrapApplication(AppComponent, {...appConfig,}).catch((err) =>
  console.error(err)
);
